import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import TextField from "@material-ui/core/TextField";
import { FileUpload } from "primereact/fileupload";
import { Calendar } from "primereact/calendar";

import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import { PaymentApprovalActions } from "../../actions";
import tableRequest from "../../models/tableRequest";
// import { userTypeMasterActions } from '../../actions';
import Switch from "@material-ui/core/Switch";
import { Dropdown } from "primereact/dropdown";
import { TabView, TabPanel } from "primereact/tabview";
import { MultiSelect } from "primereact/multiselect";

class PaymentApproval extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.tblResponse2 = new tableRequest();
    this.statusBodyTemplate = this.statusBodyTemplate.bind(this);
    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);

    this.isUniqueGiftList = this.isUniqueGiftList.bind(this);

    // this.actionBodyTemplateSubCate = this.actionBodyTemplateSubCate.bind(this);
    this.switchToggleConfirm = this.switchToggleConfirm.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.openDialog = this.openDialog.bind(this);
    // this.openDialog2 = this.openDialog2.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
    this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this);
    this.resetForm = this.resetForm.bind(this);

    this.onHide = this.onHide.bind(this);
    this.onHide2 = this.onHide2.bind(this);
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.onPage2 = this.onPage2.bind(this);
    this.onSort2 = this.onSort.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);
    this.photoBodyTemplate = this.photoBodyTemplate.bind(this);
    this.photoBodyTemplateSubCate = this.photoBodyTemplateSubCate.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.setSubCateImagePath = this.setSubCateImagePath.bind(this);

    this.state = {
      id: "",
      IsAdd: true,
      activeIndex: 0,
      IsEdit: true,
      IsEdit2: true,
      ThreesholdValue: 0,
      LoyaltyPoints: 0,
      first: 0,
      first2: 0,
      rows: 5,
      rows2: 5,
      sliderImage: "",
      AddMoreGift: [{ key: "", value: "", IsClaimed: 0 }],
      SubCateImage: "",
      totalRecords: 0,
      totalRecords2: 0,
      globalFilter: null,
      sortOrder: "",
      sortOrder2: "",
      buttonLabel: "Submit",
      switchAction: false,
      switchAction2: false,
      formHeading: "Add Extra Benefi",
      // formHeading2: "Add Sub Category Master",
      CategoryId: 0,
      MCategoryId: 0,
      SubCatId: 0,
      // groupId: 0,
      groupId: [],
      FromDate: "",
      endDate: "",
      IsActive: true,
      CreatedDate: null,
      UpdatedDate: null,
      AdminUserId: 0,
      formError: {
        groupId: "",
        FromDate: "",
        endDate: "",
        sliderImage: [],
      },
    };
  }

  handleNext = () => {
    let isValid = this.validateAddBenefitForm();
    if (isValid) {
      this.setState({ activeIndex: 1 });
    }
  };

  validateAddBenefitForm = () => {
    let errors = { ...this.state.formError };
    let isValid = true;

    if (!this.state.groupId) {
      errors.groupId = "Please select a group";
      isValid = false;
    }

    if (!this.state.FromDate) {
      errors.FromDate = "Please select a start date";
      isValid = false;
    }

    if (!this.state.endDate) {
      errors.endDate = "Please select an end date";
      isValid = false;
    }

    if (this.state.FromDate && this.state.endDate) {
      const fromDate = new Date(this.state.FromDate);
      const endDate = new Date(this.state.endDate);
      if (endDate <= fromDate) {
        errors.endDate = "End date must be after start date";
        isValid = false;
      }
    }

    if (!this.state.sliderImage) {
      errors.sliderImage = "Please upload a banner image";
      isValid = false;
    }

    this.setState({ formError: errors });
    return isValid;
  };

  uploadFiles(e) {
    e.preventDefault();
    //console.log(this.state.file)
  }
  getDropValueOfCategory() {
    let categoryName = "";
    this.props.CategoryDataList.filter((x) => {
      if (x.value === this.state.categoryId.toString()) {
        categoryName = x.label;
      }
    });

    return categoryName;
  }

  componentDidMount() {
    const userData = JSON.parse(sessionStorage.getItem("UserData"));
    const AdminUserId = userData ? parseInt(userData, 10) : 0;
    this.setState({ AdminUserId });
    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");
      const pageName = Curenturl.substring(nNumber + 1);

      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({
            IsEdit: false,
          });
        }
        if (!obj[0].IsAdd) {
          this.setState({
            IsAdd: false,
          });
        } else {
          this.setState({
            IsAdd: true,
          });
        }
      }
    }

    this.props.fetchApi(this.tblResponse);
    this.props.getCategoryDDL();
  }
  //category
  photoBodyTemplate(e) {
    if (e?.FilePath) {
      return (
        <a href={e.FilePath} target="_blank" rel="noopener noreferrer">
          <img
            src={e.FilePath}
            width="50px"
            alt="Image Preview"
            style={{ cursor: "pointer" }}
          />
        </a>
      );
    }
    return null;
  }

  // photoBodyTemplate(e) {
  //   if (e.FilePath) {
  //     return <img src={e.FilePath} width="50px" />;
  //   }
  // }

  photoBodyTemplateSubCate(e) {
    if (e.SubCateFilePath) {
      return <img src={e.SubCateFilePath} width="50px" />;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.CategoryData) {
      if (prevProps.CategoryData !== this.props.CategoryData) {
        // this.props.myProp has a different value
        if (this.props.CategoryData) {
          var e = this.props.CategoryData;
          this.setState({
            totalRecords: e[0]?.TotalRows || 0,
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }
    // subcate
    if (this.props.SubCategoryData) {
      if (prevProps.SubCategoryData !== this.props.SubCategoryData) {
        // this.props.myProp has a different value
        if (this.props.SubCategoryData) {
          var e = this.props.SubCategoryData;
          this.setState({
            totalRecords2: e[0].TotalRows,
          });
        }
      }
    } else {
      if (this.state.totalRecords2 !== 0)
        this.setState({
          totalRecords2: 0,
          first: 0,
        });
    }
  }

  switchToggleConfirm = (e) => { 
    this.props.inActiveRow(
      this.state.id,
      //this.state.DealerId,
      this.state.switchAction,
      this.tblResponse
    );
  };

  // handleChange = (event) => {
  //   let { name, value, type, checked } = event.target;
  //   let errors = this.state.formError;

  //   // Update the field value
  //   this.setState({ [name]: value }, () => {
  //     // After setting state, validate the field
  //     this.validateForm(value, name);
  //   });
  // };

  handleChange = (event) => {
    let name, value;
    if (event && event.value !== undefined && event.originalEvent) {
      name = event.target.name;
      value = event.value;
    }
    else if (event && event.target) {
      name = event.target.name;
      value =
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value;
    }
    let errors = this.state.formError;
    this.setState({ [name]: value }, () => {
      this.validateForm(value, name);
    });
  };

  UpdatedDateTemplate(rowData) {
    formError;
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>;
    }
  }

  CreatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>;
    }
  }

  validateForm(value, name) {
    let errors = this.state.formError; // <-- FIXED: formError was missing
    let IsValid = true;

    switch (name) {
      case "groupId":
        if (!value || value.length < 1) {
          IsValid = false;
          errors.groupId = "Please Select Group name.";
        } else {
          errors.groupId = "";
        }
        break;

      case "FromDate":
        if (!value) {
          IsValid = false;
          errors.FromDate = "Please Select Start Date.";
        } else {
          errors.FromDate = "";
        }
        break;

      case "endDate":
        if (!value) {
          IsValid = false;
          errors.endDate = "Please Select End Date.";
        } else {
          errors.endDate = "";
        }
        break;

      case "sliderImage":
        if (!value || value.length < 1) {
          IsValid = false;
          errors.sliderImage = "Please Select Banner Image.";
        } else {
          errors.sliderImage = "";
        }
        break;

      default:
        break;
    }

    this.setState({ formError: errors }); // <-- Keep updating the form error state
    return IsValid;
  }
  
  // validateForm(value, name) {
  //   let errors = { ...this.state.formError }; // Copy existing errors
  //   let IsValid = true;

  //   switch (name) {
  //     case "groupId":
  //       if (!value) {
  //         IsValid = false;
  //         errors.groupId = "Please Select Group name.";
  //       } else errors.groupId = "";
  //       break;

  //     case "ThresholdValue": // Fixed typo
  //       if (!value) {
  //         IsValid = false;
  //         errors.ThresholdValue = "Please Enter Threshold Value.";
  //       } else errors.ThresholdValue = "";
  //       break;

  //     case "FromDate":
  //       if (!value) {
  //         IsValid = false;
  //         errors.FromDate = "Please Select Start Date.";
  //       } else errors.FromDate = "";
  //       break;

  //     case "endDate":
  //       if (!value) {
  //         IsValid = false;
  //         errors.endDate = "Please Select End Date.";
  //       } else errors.endDate = "";
  //       break;

  //     case "sliderImage":
  //       if (!value) {
  //         IsValid = false;
  //         errors.sliderImage = "Please Select Banner Image.";
  //       } else errors.sliderImage = "";
  //       break;

  //     default:
  //       break;
  //   }

  //   this.setState({ formError: errors });
  //   return IsValid;
  // }

  // Function to prevent duplicate keys in AddMoreGift
  isUniqueGiftList(addMoreGiftList) {
    const seen = new Set();
    return addMoreGiftList.every((gift) => {
      if (seen.has(gift.key)) {
        return false; // Duplicate key found
      }
      seen.add(gift.key);
      return true;
    });
  }
  // submitForm = (event) => {
  //   event.preventDefault();
  //   let isGiftValid = this.validateAddGiftForm();
  //   if (!isGiftValid) return;

  //   let isfrmvalid = true;
  //   const formErrorCopy = { ...this.state.formError };

  //   Object.keys(formErrorCopy).forEach((key) => {
  //     const value = this.state[key];
  //     const isValid = this.validateForm(value, key);
  //     if (!isValid) {
  //       isfrmvalid = false;
  //     }
  //   });

  //   if (!isfrmvalid) return;

  //   if (!this.isUniqueGiftList(this.state.AddMoreGift)) {
  //     alert(
  //       "Duplicate Gift Name found in AddMoreGift. Please remove duplicates before submitting."
  //     );
  //     return;
  //   }
  //   const formData = {
  //     id: this.state.id,
  //     groupId: this.state.groupId,
  //     createdby: this.state.AdminUserId,
  //     StartDate: format(new Date(this.state.FromDate), "yyyy-MM-dd"),
  //     EndDate: format(new Date(this.state.endDate), "yyyy-MM-dd"),
  //     GiftImg: this.state.sliderImage,
  //     AddMoreGift: JSON.stringify(
  //       this.state.AddMoreGift.map((gift) => ({
  //         ...gift,
  //         IsClaimed: 0,
  //       }))
  //     ),
  //     CreatedDate:
  //       this.state.groupId > 0
  //         ? this.state.CreatedDate
  //         : this.getCurrentDateMMDDYYY(),
  //     UpdatedDate: this.state.groupId > 0 ? this.getCurrentDateMMDDYYY() : null,
  //     TotalRows: this.state.totalRecords,
  //   };

  //   if (formData.id > 0) {
  //     this.props.updateCategory(formData);
  //     this.resetForm();
  //   } else {
  //     this.props.createCategory(formData, this.tblResponse);
  //     this.resetForm();
  //   }

  //   if (!this.props.showDialog) {
  //     this.resetForm();
  //   }
  // };
  submitForm = (event) => {
    event.preventDefault();
    let isGiftValid = this.validateAddGiftForm();
    if (!isGiftValid) return;

    let isfrmvalid = true;
    const formErrorCopy = { ...this.state.formError };

    Object.keys(formErrorCopy).forEach((key) => {
      const value = this.state[key];
      const isValid = this.validateForm(value, key);
      if (!isValid) {
        isfrmvalid = false;
      }
    });

    if (!isfrmvalid) return;

    if (!this.isUniqueGiftList(this.state.AddMoreGift)) {
      alert("Duplicate Gift Name found in AddMoreGift.");
      return;
    }

    const selectedGroups = this.state.groupId;
    selectedGroups.forEach((groupId) => {
      const formData = {
        id: this.state.id,
        groupId: groupId,
        createdby: this.state.AdminUserId,
        StartDate: format(new Date(this.state.FromDate), "yyyy-MM-dd"),
        EndDate: format(new Date(this.state.endDate), "yyyy-MM-dd"),
        GiftImg: this.state.sliderImage,
        AddMoreGift: JSON.stringify(
          this.state.AddMoreGift.map((gift) => ({
            ...gift,
            IsClaimed: 0,
          }))
        ),
        CreatedDate:
          groupId > 0 ? this.state.CreatedDate : this.getCurrentDateMMDDYYY(),
        UpdatedDate: groupId > 0 ? this.getCurrentDateMMDDYYY() : null,
        TotalRows: this.state.totalRecords,
      };

      if (formData.id > 0) {
        this.props.updateCategory(formData);
        this.resetForm();
      } else {
        this.props.createCategory(formData, this.tblResponse);
        this.resetForm();
      }
    });

    if (!this.props.showDialog) {
      this.resetForm();
    }
  };
  validateAddGiftForm = () => {
    let errors = { ...this.state.formError };
    let isValid = true;

    const isGiftEmpty = this.state.AddMoreGift.some(
      (gift) => !gift.key || !gift.value
    );
    if (isGiftEmpty) {
      errors.AddMoreGift = "Please fill in all gift details";
      isValid = false;
    }
    this.setState({ formError: errors });
    return isValid;
  };

  resetForm() {
    this.setState({
      groupId: 0,
      FilePath: "",
      FromDate: "",
      endDate: "",
      IsActive: true,
      sliderImage: "",
      AddMoreGift: [],
      formError: {
        groupId: "",
      },
    });

    let errors = this.state.formError;
    Object.entries(errors).map(([key]) => {
      errors[key] = "";
      return errors[key];
    });
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }
  //to lazy loadsubCate
  getLazyLoadingValuesSubCate(event) {
    this.setState({ rows2: event.rows, first2: event.first });
    this.tblResponse2.PageSize = event.rows;
    this.tblResponse2.First = event.first + 1;
    this.tblResponse2.IsActive = true;
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse2.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }
  onPage(event) {
    this.props.loadingData(true);

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }

  onPage2(event) {
    this.props.loadingData2(true);
    setTimeout(() => {
      this.getLazyLoadingValuesSubCate(event);
      this.props.SubCatefetchApi(this.tblResponse2);
    }, 250);
  }

  //to search
  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse);
  }
  onSort2(event) {
    this.props.loadingData2(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse2.SortColumn = sortField ? sortField : "";
    this.tblResponse2.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.SubCatefetchApi(this.tblResponse2);
  }

  onHide() {
    this.props.onHideShow(false);
    this.resetForm();
  }
  onHide2() {
    this.props.onHideShow2(false);
    this.resetForm2();
  }

  openDialog() {
    this.props.onHideShow(true);
    this.setState({ buttonLabel: "Submit", formHeading: "Add Extra Benefit" });
  }
  // openDialog2() {
  //   this.props.onHideShow2(true);
  //   this.setState({ buttonLabel: "Submit", formHeading2: "Add Sub Category" });
  // }

  statusBodyTemplate(rowData) {
    if (rowData) {
      return (
        <Checkbox
          disabled
          checked={rowData.IsActive}
          color="primary"
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
      );
    }
  }

  getCurrentDateMMDDYYY() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.AddMoreGift];
    list[index][name] = value;
    this.setState({ AddMoreGift: list });
  };

  // handle click event of the Remove button
  handleRemoveClick = (index) => {
    const list = [...this.state.AddMoreGift];
    list.splice(index, 1);
    this.setState({ AddMoreGift: list });
  };

  // handle click event of the Add button
  handleAddClick = () => {
    this.setState({
      AddMoreGift: [
        ...this.state.AddMoreGift,
        { key: "", value: "", IsClaimed: 0 },
      ],
    });
  };

  /// this use for category
  actionBodyTemplate(rowData) { debugger
    const editMode = (e) => {
      this.props.onHideShow(true);
      this.setState({
        buttonLabel: "Update",
        formHeading: "Update Extra Benefit",
        id: rowData.id,
        // groupId: rowData.CategoryId == null ? 0 : rowData.CategoryId,
        groupId: rowData.CategoryId != null ? [rowData.CategoryId] : [],
        GroupName: rowData.CategoryName,
        FromDate: rowData.StartDate ? new Date(rowData.StartDate) : null,
        endDate: rowData.EndDate ? new Date(rowData.EndDate) : null,
        IsActive: rowData.IsActive,
        CreatedDate: rowData.CreatedDate,
        sliderImage: rowData.FilePath,

        LoyaltyPoints: rowData.LoyaltyPoints,
        // AddMoreGift:
        // rowData.AddMoreGift != null
        //   ? JSON.parse(rowData.AddMoreGift)
        //   : [{ key: "", value: "" ,IsClaimed:0}],

        AddMoreGift:
          rowData.AddMoreGift != null
            ? JSON.parse(rowData.AddMoreGift).map((item) => ({
                ...item,
                IsClaimed: 0,
              }))
            : [{ key: "", value: "", IsClaimed: 0 }],
      });
    };

    const switchHandleChange = (e) => {
      this.setState({
        switchAction: !rowData.IsActive,
        id: rowData.DealerId,
      });
      this.props.onHideShowIsActive(true);
    };

    if (rowData) {
      return (
        <>
          {this.state.IsEdit === true ? (
            <div>
              <Switch
                checked={rowData.IsActive}
                color="primary"
                name={rowData.groupId}
                onChange={switchHandleChange}
                inputProps={{ "aria-label": "secondary checkbox" }}
              />
              <Button icon="pi pi-pencil" onClick={editMode} />
            </div>
          ) : (
            ""
          )}
        </>
      );
    }
  }

  // set Category Image Path
  setImagePath(event) {
    let errors = this.state.formError;
    errors.sliderImage = "";
    //errors.promotionalImage="";
    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              sliderImage: response.Source,
              //promotionalImage: response.Source
            });
          } else if (response.ResponseCode === "400") {
            errors.sliderImage = "Only image format is accepted.";
            this.setState({
              sliderImage: [],
              //promotionalImage:[],
            });
          } else {
            // this.messageService.add({ severity: 'error', summary: 'Oops', detail: response.ResponseMessage });
          }
        } else {
          //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
        }
      } else {
        //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
      }
    } else {
      //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    }
  }

  // set Category Image Path
  setSubCateImagePath(event) {
    let errors = this.state.formError;
    errors.SubCateImage = "";
    //errors.promotionalImage="";
    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              SubCateImage: response.Source,
              //promotionalImage: response.Source
            });
          } else if (response.ResponseCode === "400") {
            errors.SubCateImage = "Only image format is accepted.";
            this.setState({
              SubCateImage: [],
              //promotionalImage:[],
            });
          } else {
            // this.messageService.add({ severity: 'error', summary: 'Oops', detail: response.ResponseMessage });
          }
        } else {
          //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
        }
      } else {
        //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
      }
    } else {
      //this.messageService.add({ severity: 'error', summary: 'Oops', detail: 'Something went wrong' });
    }
  }
  render() {
    const renderFooter = (name) => {
      return (
        <div>
          <Button
            label="No"
            icon="pi pi-times"
            onClick={() => this.props.onHideShowIsActive(false)}
            className="p-button-text"
          />
          <Button
            label="Yes"
            icon="pi pi-check"
            onClick={this.switchToggleConfirm}
            autoFocus
          />
        </div>
      );
    };
    const header = (
      <div className="table-header row ">
        <div className="col-md-6 master_headhingcol">
          <h4 className="user">Payment Approval</h4>
        </div>
        <div className="col-md-6 text-right">
          <span className="p-input-icon-left mr-2">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={(e) => this.searchFilter(e)}
              placeholder="Global Search"
            />
          </span>

          {/* {this.state.IsAdd === true ? (
            <Button
              className="mr-2"
              label="Add Extra Benefit"
              icon="pi pi-plus-circle"
              onClick={this.openDialog}
            />
          ) : (
            <Button
              className="mr-2"
              label="Add category"
              icon="pi pi-plus-circle"
              style={{ display: "none" }}
              onClick={this.openDialog}
            />
          )} */}
        </div>
      </div>
    );

    // Template for "Add Gift to this Group"

    return (
      <div className="datatable-filter-demo dash-margin">
        <ToastContainer />

        <div className="card">
          <DataTable
            value={this.props.CategoryData}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            header={header}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20]}
            totalRecords={parseInt(this.state.totalRecords)}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              style={{ width: "40%" }}
              field="UserName"
              header="Dealer Name"
              sortable
            ></Column>

            {/* <Column
              style={{ width: "40%" }}
              field="GiftName"
              header="Gift Name"
              sortable
            ></Column> */}
            {/* <Column
              style={{ width: "40%" }}
              field="FilePath"
              id="zoomA"
              header="Banner Image"
              body={this.photoBodyTemplate}
              sortable
            ></Column> */}

            <Column
              style={{ width: "40%" }}
              field="Address"
              header="Address"
              sortable
            ></Column>
            <Column
              style={{ width: "40%" }}
              field="CreatedDate"
              header="Created Date"
              sortable
            ></Column>
            {this.state.IsEdit === true ? (
              <Column
                field="Action"
                header="IsPayment"
                style={{ width: "20%" }}
                body={this.actionBodyTemplate}
              ></Column>
            ) : (
              <Column
                field="Action"
                header="Action"
                style={{ width: "20%", display: "none" }}
              ></Column>
            )}
          </DataTable>
        </div>        
        <Dialog
          header={this.state.formHeading}
          modal
          dismissableMask={false}
          visible={this.props.showDialog}
          className="popup"
          onHide={this.onHide}
        >
          <TabView
            activeIndex={this.state.activeIndex}
            onTabChange={(e) => this.setState({ activeIndex: e.index })}
          >
            <TabPanel header="Add Benefit">
              <form onSubmit={this.submitForm} autocomplete="off">
                <div className="row">
                  {/* <div className="col-md-4 pt-2">
                    <Dropdown
                      onChange={this.handleChange}
                      name="groupId"
                      options={this.props.CategoryDataList}
                      optionLabel="label"
                      optionValue="value"
                      value={this.state.groupId.toString()}
                      filter
                      className="form-control custom-select"
                      placeholder="Select Group*"
                    ></Dropdown>
                    {this.state.formError.groupId !== "" ? (
                      <div className="error">
                        {this.state.formError.groupId}
                      </div>
                    ) : (
                      ""
                    )}
                  </div> */}
                  <div className="col-md-4 pt-2">
                    <MultiSelect
                      name="groupId"
                      value={this.state.groupId}
                      options={this.props.CategoryDataList}
                      optionLabel="label"
                      optionValue="value"
                      onChange={this.handleChange}
                      filter
                      placeholder="Select Groups"
                      display="chip"
                      className="form-control custom-select"
                      appendTo={document.body}
                    />
                    {this.state.formError.groupId !== "" ? (
                      <div className="error">
                        {this.state.formError.groupId}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-4 pt-2">
                    <Calendar
                      placeholder="From Date"
                      showIcon={true}
                      name="FromDate"
                      value={this.state.FromDate}
                      onChange={this.handleChange}
                      appendTo={document.getElementById("root")}
                      minDate={new Date()}
                      dateFormat="dd-mm-yy" 
                    />
                    {this.state.formError.FromDate !== "" ? (
                      <div className="error">
                        {this.state.formError.FromDate}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-4 pt-2">
                    <Calendar
                      placeholder="End Date"
                      showIcon={true}
                      name="endDate"
                      value={this.state.endDate}
                      onChange={this.handleChange}
                      appendTo={document.getElementById("root")}
                      minDate={new Date()}
                      dateFormat="dd-mm-yy" // Prevents backdate selection
                    />
                    {this.state.formError.endDate !== "" ? (
                      <div className="error">
                        {this.state.formError.endDate}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <br></br>
                  <br></br> <br></br>
                  <div className="fileslider col-md-4 col-xl-4">
                    {/* <span>Upload Banner Image</span> */}
                    <FileUpload
                      name="sliderImage"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePath}
                      onChange={this.fileSelectedHandler}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {/* <button type="button" className="btn btn-warning btn-block" onClick={this.submitForm}>Upload</button> */}
                  </div>
                  <div className="fileslider col-md-2 col-xl-4">
                    {this.state.IsEdit === true ? (
                      <Button
                        label="Next"
                        icon="pi pi-arrow-right"
                        onClick={this.handleNext}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="fileslider col-md-8 col-xl-8">
                    <TextField
                      disabled
                      hidden
                      id="standard-basic"
                      size="small"
                      onChange={this.handleChange}
                      value={this.state.sliderImage}
                      name="shareurl"
                      variant="outlined"
                      className="width"
                      label="File Url : "
                    />
                    <div className="blockimgprive">
                      {this.state.sliderImage ? (
                        <div className="p-fileupload-content mt-3 p-1">
                          <div>
                            <img
                              alt=" "
                              role="presentation"
                              src={this.state.sliderImage}
                              width="150"
                              height="100"
                            />
                          </div>
                        </div>
                      ) : null}

                      {this.state.formError.sliderImage !== null ? (
                        <div className="error">
                          {this.state.formError.sliderImage}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </form>
            </TabPanel>
            <TabPanel header="Add Gift">
              <div style={{ overflowX: "hidden", width: "100%" }}>
                <div className="col-md-12 text-right">
                  <Button
                    onClick={this.handleAddClick}
                    label="Add"
                    icon="pi pi-plus"
                  />
                </div>

                {this.state.AddMoreGift.map((x, i) => {
                  return (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Gift Name:</label>
                          <input
                            name="key"
                            className="form-control"
                            placeholder="Enter Gift Name"
                            value={x.key}
                            onChange={(e) => this.handleInputChange(e, i)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Value:</label>
                          <input
                            className="form-control"
                            name="value"
                            placeholder="Enter Value"
                            value={x.value}
                            onChange={(e) => this.handleInputChange(e, i)}
                          />
                        </div>
                      </div>
                      <div className="col-md-2 pt-4">
                        {this.state.AddMoreGift.length !== 1 && (
                          <Button
                            icon="pi pi-times"
                            onClick={() => this.handleRemoveClick(i)}
                            className="p-button-rounded p-button-danger p-button-text"
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
                <div className="col-md-12 text-center">
                  <Button
                    label="Submit"
                    icon="pi pi-check"
                    onClick={this.submitForm}
                  />
                </div>
              </div>
              {/* <div className="col-md-12 text-center">
                {this.state.IsEdit === true ? (
                  <Button
                    onClick={(e) => this.submitForm(e)}
                    label={this.state.buttonLabel}
                    icon="pi pi-check"
                  />
                ) : (
                  <Button
                    label={this.state.buttonLabel}
                    icon="pi pi-check"
                    style={{ display: "none" }}
                  />
                )}
              </div> */}
            </TabPanel>
          </TabView>
        </Dialog>

        <Dialog
          header="Confirmation"
          visible={this.props.showIsActiveDialog}
          modal
          style={{ width: "350px" }}
          footer={renderFooter("displayConfirmation")}
          onHide={() => this.props.onHideShowIsActive(false)}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3 confirm-icon"
              style={{ fontSize: "2rem" }}
            />
            <span>
              Are you sure you want to{" "}
              {this.state.switchAction == true ? "Approved" : "Not Approved"}?
            </span>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
   console.log("Data",state)
  return {
    CategoryData: state.category.items,
    SubCategoryData: state.category.subItems,
    showDialog: state.category.showDialog,
    showDialog2: state.category.showDialog2,
    loading: state.category.loding,
    loading2: state.category.loding2,
    showIsActiveDialog: state.category.showIsActiveDialog,
    showIsActiveDialog2: state.category.showIsActiveDialog2,
    CategoryDataList: state.category.categoryddl,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(PaymentApprovalActions.getAll(obj));
    },
    SubCatefetchApi: (obj) => {
      dispatch(PaymentApprovalActions.getSubAll(obj));
    },
    createCategory: (category, obj) =>
      dispatch(PaymentApprovalActions.createCatagory(category, obj)),
    updateCategory: (category) =>
      dispatch(PaymentApprovalActions.updateCategory(category)),
    SubUpdateCategory: (category) =>
      dispatch(PaymentApprovalActions.SubUpdateCategory(category)),
    createSubCategory: (category) =>
      dispatch(PaymentApprovalActions.createSubCategory(category)),
    inActiveRow: (category, isActive) =>
      dispatch(PaymentApprovalActions.inActiveRow(category, isActive)),
    inActiveRow2: (category, isActive) =>
      dispatch(PaymentApprovalActions.inActiveRow2(category, isActive)),
    onHideShow: (isbool) =>
      dispatch(PaymentApprovalActions.onHideShow(isbool)),
    onHideShow2: (isbool) =>
      dispatch(PaymentApprovalActions.onHideShow2(isbool)),
    onHideShowIsActive: (isbool) =>
      dispatch(PaymentApprovalActions.onHideShowIsActive(isbool)),
    onHideShowIsActive2: (isbool) =>
      dispatch(PaymentApprovalActions.onHideShowIsActive2(isbool)),
    loadingData: (isLoding) =>
      dispatch(PaymentApprovalActions.loadingData(isLoding)),
    loadingData2: (isLoding) =>
      dispatch(PaymentApprovalActions.loadingData2(isLoding)),
    getCategoryDDL: (data) =>
      dispatch(PaymentApprovalActions.getCategoryDDL(data, 1)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentApproval);